<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <div slot="header">
        <i class="fa fa-list mr-2"></i>
        <strong>Liste des chargements Prest'IJ</strong>
        <div class="card-header-actions">
          <b-link class="card-header-action btn-minimize" v-b-toggle.collapse2>
            <span class="when-opened"><i class="icon-arrow-down"></i></span>
            <span class="when-closed"><i class="icon-arrow-up"></i></span>
          </b-link>
        </div>
      </div>
      <b-collapse id="collapse2" visible>
        <b-card-body>
          <b-row>
            <b-col md="2" class="mt-2">
              <span>Chargement Prest'IJ : </span>
            </b-col>
            <b-col md="5">
              <b-form-group label-for='nom_fichier'>
                <b-form-file placeholder="Joindre un fichier"
                             class="file-input"
                             drop-placeholder="Déposer le fichier ici..."
                             browse-text="Parcourir"
                             :state="errors.attachment !== '' ? false : null"
                             @change="addFile($event)">
                </b-form-file>
                <span class="field-error">{{ errors.attachment }}</span>
              </b-form-group>
            </b-col>
            <!-- <b-col md="2" v-if="canExecute(rules.CAN_EXECUTE_CHARGEMENT_FLUX)">
              <b-form-checkbox
                id="checkbox-reprise"
                v-model="casParticulier"
                name="casParticulier"
                value="reprise_stock_access_mai_2021"
              >
                Reprise Histo. Access
              </b-form-checkbox>
            </b-col> -->
            <b-col md="2">
              <b-button type="enter" @click.prevent="importFile" size="md" variant="primary" :disabled="isChargementProcessing">
                <i class="fa fa-upload"></i> Importer
              </b-button>
            </b-col>
          </b-row>
          <v-server-table @loaded="onLoaded" ref="table" :columns="columns" :url="url" :options="options" style="overflow: hidden;">
            <div v-if="props.row.date_import" slot="date_import" slot-scope="props" class="slot-date">
              <span class="badge badge-success p-2">{{ formatDate(props.row.date_import) }}</span>
            </div>
            <div v-if="props.row.nom_gestionnaire" slot="nom_gestionnaire" slot-scope="props">
              {{ props.row.nom_gestionnaire }} {{ props.row.prenom_gestionnaire }}
            </div>
            <div v-if="props.row.min_date_periode && !isEmpty(props.row.finished_at)" slot="min_date_periode" slot-scope="props" class="slot-date">
              {{ formatDate(props.row.min_date_periode) }}
            </div>
            <div v-else slot="min_date_periode" slot-scope="props" class="">
              -
            </div>
            <div v-if="props.row.max_date_periode && !isEmpty(props.row.finished_at)" slot="max_date_periode" slot-scope="props" class="slot-date">
              {{ formatDate(props.row.max_date_periode) }}
            </div>
            <div v-else slot="max_date_periode" slot-scope="props" class="">
              -
            </div>
            <div v-if="props.row.nom_fichier && !isEmpty(props.row.finished_at)" slot="nom_fichier" slot-scope="props">
              {{ props.row.nom_fichier }} <i v-if="!isEmpty(props.row.chemin)" class="ml-2 fa fa-download clickable" @click="downloadFile(props.row)"></i>
            </div>
            <div v-else slot="nom_fichier" slot-scope="props">
              {{ props.row.nom_fichier }} en cours de chargement, commncé {{ runTime }}
            </div>
            <div slot="nb_lignes_ok" slot-scope="props" v-if="!isEmpty(props.row.finished_at)">
              <span class="badge badge-success p-2 mr-2" v-if="props.row.nb_lignes_ok !== 0"> {{ props.row.nb_lignes_ok }} OK </span>
              <span class="badge badge-warning p-2" v-if="props.row.nb_lignes_ok !== 0 && props.row.nb_lignes_ok < props.row.nb_lignes_total"> {{ (props.row.nb_lignes_total * 1) - (props.row.nb_lignes_ok * 1)  }} KO</span>
              <span class="badge badge-danger p-2" v-if="props.row.nb_lignes_ok === 0">{{ props.row.nb_lignes_total }} KO</span>
            </div>
            <div slot="action" slot-scope="props">
              <b-button v-if="props.row.rapport_chargement_prestij.length > 0" type="button"
                        @click.prevent="seeErrors(props.row.id)" class="badge badge-info mr-3 p-2">
                <i class="fa fa-eye"></i> Voir
              </b-button>
            </div>
          </v-server-table>
          <div v-if="canExecute(rules.CAN_EXECUTE_CHARGEMENT_FLUX)">
            <b-row class="mt-2">
              <b-col>
                <b-button type="enter" v-if="!isA1Processing" @click.prevent="executeTraitement('A1')" class="p-2 mr-2" size="md" variant="warning">
                  <i class="fa fa-upload"></i> Traitement "A 1"
                </b-button>
                <b-button type="enter" v-if="isA1Processing" class="p-2 mr-2" size="md" variant="warning" disabled>
                  <i class="fa fa-upload"></i> Traitement A 1 en cours
                </b-button>
                <b-button type="enter" v-if="!isA2Processing" @click.prevent="executeTraitement('A2')" class="p-2 mr-2" size="md" variant="warning">
                  <i class="fa fa-upload"></i> Traitement "A 2"
                </b-button>
                <b-button type="enter" v-if="isA2Processing" class="p-2 mr-2" size="md" variant="warning" disabled>
                  <i class="fa fa-upload"></i> Traitement A 2 en cours
                </b-button>
                <b-button type="enter" v-if="!isB1Processing" @click.prevent="executeTraitement('B1')" class="p-2  mr-2" size="md" variant="warning">
                  <i class="fa fa-upload"></i> Traitement "B 1"
                </b-button>
                <b-button type="enter" v-if="isB1Processing" class="p-2 mr-2  mr-2" size="md" variant="warning" disabled>
                  <i class="fa fa-upload"></i> Traitement B 1 en cours
                </b-button>
                <b-button type="enter" v-if="!isB2Processing" @click.prevent="executeTraitement('B2')" class="p-2  mr-2" size="md" variant="warning">
                  <i class="fa fa-upload"></i> Traitement "B 2"
                </b-button>
                <b-button type="enter" v-if="isB2Processing" class="p-2 mr-2" size="md" variant="warning" disabled>
                  <i class="fa fa-upload"></i> Traitement B 2 en cours
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="traitementA1.duration != null">
              <b-col>
                <span>Durée du dernier Traitement A 1 : {{traitementA1.duration}}</span>
              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="traitementA2.duration != null">
              <b-col>
                <span>Durée du dernier Traitement A 2 : {{traitementA2.duration}}</span>
              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="traitementB1.duration != null">
              <b-col>
                <span>Durée du dernier Traitement B 1 : {{traitementB1.duration}}</span>
              </b-col>
            </b-row>
            <b-row class="mt-2" v-if="traitementB2.duration != null">
              <b-col>
                <span>Durée du dernier Traitement B 2 : {{traitementB2.duration}}</span>
              </b-col>
            </b-row>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import {hasRule, espaceGestionRules} from "@/utils/rulesHelper";
  import {isEmpty, downloadFile} from "@/utils/fileHelper";
  import moment from 'moment';


  export default {
    name: "List",
    data() {
      let self = this;
      return {
        checkJob: null,
        timer: null,
        runTime: null,
        isEmpty,
        url: '',
        rules: espaceGestionRules,
        dataIsReady: false,
        attachment: null,
        casParticulier: null,
        errors: {
          attachment: '',
        },
        columns: ['date_import', 'nom_gestionnaire', 'profil_gestionnaire', 'min_date_periode', 'max_date_periode', 'nom_fichier', 'nb_lignes_ok', 'action'],
        items: [],
        options: {
          headings: {
            date_import: 'Date import',
            nom_gestionnaire: 'Nom Prénom',
            profil_gestionnaire: 'Profil utilisateur',
            min_date_periode: 'Min date période',
            max_date_periode: 'Max date période',
            nom_fichier: 'Nom Fichier',
            nb_lignes_ok: 'Nb de lignes /\nStatut',
            action: 'Rapport',
          },
          perPage: 10,
          filterable: false,
          sortable: ['date_import', 'nom_gestionnaire', 'profil_gestionnaire', 'min_date_periode', 'max_date_periode', 'nom_fichier'],
          perPageValues: [10, 25, 50],
          requestFunction: function (data) {
            self.url = '/espaceGestion/chargement_prestij/list'
            self.$store.commit("IS_LOADING", true);
            return axios.get(self.url, {
              params: data
            })
              .then(function (response) {
                self.$store.commit('IS_LOADING', false)
                // console.log('response',response)
                for (let row of response.data.data) {
                  if (isEmpty(row.finished_at)) {
                    self.isChargementProcessing = true;
                    self.runTime = self.getRunTime(row.created_at); // pour le premier affichage
                    
                    if (isEmpty(self.timer)) {
                      self.timer = setInterval(() => {
                        self.runTime = self.getRunTime(row.created_at);
                      }, 5000); // récupère toutes les minutes
                    }
                    
                    self.startListeningCompletionTask(row.id);
                  }
                }
                return response;
              })
              .catch(function (e) {
                self.$store.commit("IS_LOADING", false);
                self.$swal({
                  position: "top",
                  type: "error",
                  title: "Attention !!",
                  text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
                  showConfirmButton: false,
                  timer: 5000
                });
              }.bind(this));
          },
          rowClassCallback: function(row) {
            if(isEmpty(row.finished_at)){
              return 'bg-info';
            }
          },
        },
        traitementA1: {
          libelle_technique: null,
          date_start: null,
          date_stop: null,
          duration: null,
        },
        traitementA2: {
          libelle_technique: null,
          date_start: null,
          date_stop: null,
          duration: null,
        },
        traitementB1: {
          libelle_technique: null,
          date_start: null,
          date_stop: null,
          duration: null,
        },
        traitementB2: {
          libelle_technique: null,
          date_start: null,
          date_stop: null,
          duration: null,
        },
        isA1Processing: false,
        isA2Processing: false,
        isB1Processing: false,
        isB2Processing: false,
        isChargementProcessing: false,
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.traitementPresijList();
      // this.all();
      moment.locale('fr');
    },
    beforeDestroy() {
      clearInterval(this.timer);
      clearInterval(this.checkJob);
    },
    methods: {
      startListeningCompletionTask(id) {
        // console.log('on commence à récupérer l état d avancement de la ligne d id '+id)
        let self = this;
        if (isEmpty(this.checkJob)) {
          this.checkJob = setInterval(() => {
              self.getInfoJob(id);
            }, 30000);
        }
      },
      getRunTime(rowCreatedAt) {
        let today = new Date();
        let createdAt = new Date(rowCreatedAt);
        let diffMs = (today - createdAt); // milliseconds between now & createdAt
        let diffHrs = Math.floor(Math.abs(diffMs) / (1000 * 60 * 60) % 24); // hours
        let diffMins = Math.floor(Math.abs(today.getTime() - createdAt.getTime()) / (1000 * 60) % 60); // minutes
        diffMins = diffMins.toString().padStart(2, '0');
        let diffSec = Math.round(Math.abs(today.getTime() - createdAt.getTime()) / (1000) % 60); // secondes
        diffSec = diffSec.toString().padStart(2, '0');
        return 'il y a '+diffHrs+'h'+diffMins+'min'+diffSec+'s';
      },
      getInfoJob(id) {
        let self = this;
        this.$axios
          .get('/espaceGestion/chargement_prestij/job/'+id)
          .then(response => {
            let job = response.data.job;
            // console.log('job',job)
            if (!isEmpty(job.finished_at)) {
              clearInterval(this.timer);
              clearInterval(this.checkJob);
              this.isChargementProcessing = false;
              this.$refs['table'].refresh();
              // window.location.reload();
            }
          })
          .catch((error) => {
            clearInterval(self.checkJob);
            self.handleErrors(error);
          });
      },
      onLoaded() {
        this.$store.commit("IS_LOADING", false);
      },
      addFile(event) {
        this.attachment = event.target.files[0];
      },
      importFile() {
        let self = this;
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let formData = new FormData();
          formData.append('file', this.attachment);
          formData.append('casParticulier', this.casParticulier);
          this.$axios
            .post(`/espaceGestion/chargement_prestij/import_excel/import`, formData, {headers: {'Content-Type': 'multipart/form-data'}})
            .then(() => {
              // this.all();
              // this.$refs['table'].refresh();
              // this.$store.commit("IS_LOADING", false);
              // this.$swal({
              //   position: 'top',
              //   type: 'success',
              //   title: 'Ajout avec succès',
              //   text: "L'import a bien été fait",
              //   showConfirmButton: false,
              //   timer: 3000
              // });
            })
            .catch((error) => {
              self.handleErrors(error);
            });
          // On n'attend pas la réponse pour effectuer une tâche de fond
          setTimeout(() => {
            this.$store.commit("IS_LOADING", false);
            this.$refs['table'].refresh();
          }, "2000")
          // _.debounce(function() {
          //   this.$store.commit("IS_LOADING", false);
          //   this.$refs['table'].refresh();
          //   // window.location.reload();
          // },2000)
        }
      },
      all() {
        let self = this;
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/espaceGestion/chargement_prestij/list")
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.items = response.data.data;
            this.dataIsReady = true;
          })
          .catch((error) => {
            self.handleErrors(error);
          });
      },
      formatDate(textDate) {
        return textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (this.attachment === null) {
          this.errors.attachment = "Veuillez choisir un fichier";
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.attachment = "";
      },
      seeErrors(chargement_id) {
        window.open(`/espace-gestion/chargement-prestij/erreurs/${chargement_id}`, '_blank');
      },
      handleErrors(error) {
        console.log(error)
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: 'Une erreur système est survenue, si le problème persiste merci de faire un ticket au support DOSI',
          showConfirmButton: false,
          timer: 4000,
        });
      },
      executeTraitement(type) {
        let self = this;
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get(`/espaceGestion/chargement_prestij/ExecuteChargementFluxDossier/${type}`)
          .then((response) => {
            this.$store.commit("IS_LOADING", false);
            if(response.data.error) {
              this.displayPopup('warning', 'Attention !', response.data.message);
            } else {
              this.displayPopup('success', 'Traitement lancé', 'Le traitement est lancé');
            }
          })
          .catch((error) => {
            self.handleErrors(error);
          });
      },
      canExecute(rule) {
        return hasRule(rule);
      },
      traitementPresijList() {
        let self = this;
        this.$axios
          .get('/espaceGestion/admin_traitement_prestij/list')
          .then((response) => {
            this.traitementA1 = response.data.data.find(element => element.libelle_technique === 'update_dossier_prestij_neutralise_1');
            this.traitementA2 = response.data.data.find(element => element.libelle_technique === 'update_dossier_prestij_neutralise_2');
            this.traitementB1 = response.data.data.find(element => element.libelle_technique === 'chargement_brut_prestij_1');
            this.traitementB2 = response.data.data.find(element => element.libelle_technique === 'chargement_brut_prestij_2');
            this.isA1Processing = this.traitementA1.date_stop === null;
            this.isA2Processing = this.traitementA2.date_stop === null;
            this.isB1Processing = this.traitementB1.date_stop === null;
            this.isB2Processing = this.traitementB2.date_stop === null;
            this.getTreatmentDuration();
          })
          .catch(() => {
            self.handleErrors();
          });
      },
      displayPopup(type, title, text) {
        this.$swal({
          position: 'top',
          type: type,
          title: title,
          text: text,
          showConfirmButton: false,
          timer: 3000
        });
      },
      getTreatmentDuration() {
        // Durée du dernier Traitement A 1
        if(this.traitementA1.date_start !== null && this.traitementA1.date_stop !== null) {
          const ms = moment(this.traitementA1.date_stop,"YYYY-MM-DD HH:mm:ss").diff(moment(this.traitementA1.date_start,"YYYY-MM-DD HH:mm:ss"));
          const duration = moment.duration(ms);
          this.traitementA1.duration = `${duration.hours()}h:${duration.minutes()}m:${duration.seconds()}s`;
        }
        // Durée du dernier Traitement A 2
        if(this.traitementA2.date_start !== null && this.traitementA2.date_stop !== null) {
          const ms = moment(this.traitementA2.date_stop,"YYYY-MM-DD HH:mm:ss").diff(moment(this.traitementA2.date_start,"YYYY-MM-DD HH:mm:ss"));
          const duration = moment.duration(ms);
          this.traitementA2.duration = `${duration.hours()}h:${duration.minutes()}m:${duration.seconds()}s`;
        }
        // Durée du dernier Traitement B 1
        if(this.traitementB1.date_start !== null && this.traitementB1.date_stop !== null) {
          const ms = moment(this.traitementB1.date_stop,"YYYY-MM-DD HH:mm:ss").diff(moment(this.traitementB1.date_start,"YYYY-MM-DD HH:mm:ss"));
          const duration = moment.duration(ms);
          this.traitementB1.duration = `${duration.hours()}h:${duration.minutes()}m:${duration.seconds()}s`;
        }
        // Durée du dernier Traitement B 2
        if(this.traitementB2.date_start !== null && this.traitementB2.date_stop !== null) {
          const ms = moment(this.traitementB2.date_stop,"YYYY-MM-DD HH:mm:ss").diff(moment(this.traitementB2.date_start,"YYYY-MM-DD HH:mm:ss"));
          const duration = moment.duration(ms);
          this.traitementB2.duration = `${duration.hours()}h:${duration.minutes()}m:${duration.seconds()}s`;
        }
      },
      downloadFile(row) {
        let self = this;
        let name = row.nom_fichier.split('.')[0];
        let ext = 'csv';
        this.$store.commit('IS_LOADING', true);
        this.$axios.get('/espaceGestion/chargement-prestij/download/'+ row.id, {responseType: 'blob'})
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            downloadFile(response, name, ext);
          })
          .catch(function (error) {
            self.$store.commit('IS_LOADING', false);
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue pendant la récupération du fichier, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      },
    }
  }
</script>
